// extracted by mini-css-extract-plugin
module.exports = {"carousel_3d_container":"Carousel3d_carousel_3d_container__NndZL","carousel_3d_slider":"Carousel3d_carousel_3d_slider__Lccfk"};